import _ from 'lodash'
import {
  BACKGROUND_NOTIFICATIONS_TYPE,
  backgroundNotificationsConfig,
} from './backgroundNotificationsConfig'
import { BackgroundActivityNotification } from '../types/BackgroundActivityTypes'

export enum BACKGROUND_NOTIFICATIONS_STATUS {
  INPROGRESS = 'INPROGRESS',
  ERROR = 'ERROR',
  COMPLETED = 'COMPLETED',
}

export const setNotificationAsVisited = async (
  notification: BackgroundActivityNotification,
  updateBackgroundNotification: any,
) => {
  if (notification && notification.id) {
    await updateBackgroundNotification({
      variables: {
        notificationBulkUpdate: {
          notificationUpdates: [
            {
              id: notification.id,
              visited: true,
            },
          ],
        },
      },
    })
  }
}

export const getRecentActivities = (
  activities: BackgroundActivityNotification[],
  generatedTime: string,
) => {
  return activities.filter((activity) => isRecent(activity, generatedTime))
}

export const isRecent = (
  activity: BackgroundActivityNotification,
  generatedTime: string,
) => {
  const isRecent =
    new Date(activity.createdAt).getTime() >
      new Date(generatedTime).getTime() && !activity.visited
  return isRecent
}

export const getNotificationMessageByStatus = (
  activity: BackgroundActivityNotification,
  type: string,
) => {
  return _.find(activity.notificationMessageList, { notificationStatus: type })
}

export const triggerDownload = (
  notification: BackgroundActivityNotification,
) => {
  const notificationTypeConfig = backgroundNotificationsConfig.types.find(
    (config) => {
      return config.name === notification.type
    },
  )
  let baseUrl
  if (notificationTypeConfig) {
    baseUrl = notificationTypeConfig['baseUrlOfAction']
  } else {
    baseUrl = window.location.origin
  }
  if (notification.type === BACKGROUND_NOTIFICATIONS_TYPE.INSIGHTSEXPORT) {
    window.open(
      `${baseUrl}/download?requestId=${notification.originatorId}`,
      '_self',
    )
  } else {
    const notificationMessage = getNotificationMessageByStatus(
      notification,
      BACKGROUND_NOTIFICATIONS_STATUS.COMPLETED,
    )
    window.open(`${baseUrl}${notificationMessage?.url}`, '_self')
  }
}

export const navigateToNotificationUrl = (
  notification: BackgroundActivityNotification,
  navigate: any,
) => {
  const notificationMessage = getNotificationMessageByStatus(
    notification,
    BACKGROUND_NOTIFICATIONS_STATUS.COMPLETED,
  )
  navigate(notificationMessage?.url)
}

export const getBackgroundActivityDropdownHeaderText = (
  inProgressCount: number,
  completedCount: number,
) => {
  let backgroundActivityHeaderText
  if (inProgressCount > 0) {
    backgroundActivityHeaderText =
      inProgressCount +
      (inProgressCount === 1 ? ' task' : ' tasks') +
      ' processing in the background'
  } else if (completedCount > 0) {
    backgroundActivityHeaderText =
      completedCount +
      (completedCount === 1 ? ' task' : ' tasks') +
      ' have completed'
  } else {
    backgroundActivityHeaderText = 'There is no activity in the background'
  }
  return backgroundActivityHeaderText
}

export const isArchived = (
  allNotifications: BackgroundActivityNotification[],
  notification: BackgroundActivityNotification,
) => !!_.find(allNotifications, { id: notification.id, archived: true })

export const getGroupedAndSingleActivities = (
  activities: BackgroundActivityNotification[],
  generatedTime: string,
) => {
  const recentActivities = getRecentActivities(activities || [], generatedTime)
  const activityMapObject = (recentActivities || []).reduce(
    (mapObject, activity) => {
      const { status, type, action, archived, category, progressPercentage } =
        activity
      const inProgress = progressPercentage < 100
      const key = `${status}${type}${action}${archived}${category}${inProgress}`

      const currentList = mapObject[key] || []
      return {
        ...mapObject,
        [key]: [...currentList, activity],
      }
    },
    {} as Record<string, BackgroundActivityNotification[]>,
  )

  return Object.keys(activityMapObject).reduce<{
    singleActivities: BackgroundActivityNotification[]
    groupedActivities: any[]
  }>(
    ({ singleActivities, groupedActivities }, key) => {
      const { status, type, action, archived, category } =
        activityMapObject[key][0] || {}
      if (activityMapObject[key].length > 1) {
        const groupedObject = {
          key,
          status,
          type,
          action,
          archived,
          category,
          isMultiple: true,
          isExpanded: false,
          count: activityMapObject[key].length,
          activities: activityMapObject[key],
          notificationMessageList: [
            {
              comment: `${activityMapObject[key].length} similar activities hidden. Click Show all to see all notifications`,
              notificationStatus: status,
              title: `(${activityMapObject[key].length}) Hidden notifications`,
            },
          ],
        }

        return {
          singleActivities: singleActivities,
          groupedActivities: [...groupedActivities, groupedObject],
        }
      } else {
        return {
          singleActivities: [...singleActivities, activityMapObject[key][0]],
          groupedActivities: groupedActivities,
        }
      }
    },
    {
      groupedActivities: [],
      singleActivities: [],
    },
  )
}
